<script>
import ProjectListSelectSingle from './ProjectListSelectSingle'
import ProjectListSelectMulty from './ProjectListSelectMulty'

export default {
  components: {
    ProjectListSelectSingle,
    ProjectListSelectMulty
  },
  props: {
    multyValue: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter: {
        region: '',
        style: '',
        room: '',
        sort: '1'
      }
    }
  },
  methods: {
    visibleChange(value) {
      this.$emit('visibleChange', value)
    },
    initData(type, value, communityId) {
      switch (type) {
        case 'room':
          this.filter.room = value
          break
        case 'sort':
          this.filter.sort = value
          break
        case 'style':
          this.filter.style = value
          break
        case 'multy':
          this.filter.region = value
          break
      }
      this.$emit('init-filter', this.filter, communityId)
    }
  }
}
</script>

<template>
  <div class="project-list-select">
    <ProjectListSelectMulty
      :value="multyValue"
      @visibleChange="visibleChange"
      @change-list="initData"
    />
    <ProjectListSelectSingle
      :type="'style'"
      @visibleChange="visibleChange"
      @change-list="initData"
    />
    <ProjectListSelectSingle
      :type="'room'"
      @visibleChange="visibleChange"
      @change-list="initData"
    />
    <ProjectListSelectSingle
      :type="'sort'"
      @visibleChange="visibleChange"
      @change-list="initData"
    />
  </div>
</template>

<style lang="scss" scoped>
.project-list-select {
  display: flex;
}
</style>
